import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

// Reusable Supabase client (used only for product image storage).
export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);

// Public storage bucket that holds product images.
export const PRODUCT_BUCKET = "Product-images";

// Uploads a single File to Supabase Storage with a collision-free filename
// and returns its public URL.
export async function uploadProductImage(file) {
  const ext = file.name && file.name.includes(".") ? file.name.split(".").pop().toLowerCase() : "png";
  const uid = (typeof crypto !== "undefined" && crypto.randomUUID)
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const path = `${uid}.${ext}`;

  const { error } = await supabase.storage.from(PRODUCT_BUCKET).upload(path, file, {
    // 6 months (182.625 days) browser cache for immutable UUID-named images.
    cacheControl: "15778800",
    upsert: false,
    contentType: file.type || undefined,
  });
  if (error) throw error;

  const { data } = supabase.storage.from(PRODUCT_BUCKET).getPublicUrl(path);
  if (!data?.publicUrl) throw new Error("Could not resolve the public URL for the uploaded image.");
  return data.publicUrl;
}
